module.exports = __webpack_public_path__ + "img/commerciale.0f8a8918.png";